/**
 * A list of filters with their types.
 */
export const FILTER_TYPES = {
    'ExtraFields.VehiclePurpose': 'checkbox',
    'ExtraFields.DrivingOption': 'checkbox',
    'ExtraFields.CustomizationOptions': 'checkbox',
    Brand: 'checkbox',
    Model: 'checkbox',
    PriceOnline: 'range',
    PriceLease: 'range',
    Year: 'range',
    Mileage: 'range',
    FuelType: 'checkbox',
    Transmission: 'checkbox',
    'Accessories.Items': 'checkbox',
    ColorNumber: 'checkbox',
    IsNew: 'checkbox',
    IsSpecialOffer: 'checkbox',
    Seats: 'checkbox',
    FinanceMethod: 'checkbox'
};

/**
 * A list of filters that support "pill" selection.
 */
export const FILTERS_WITH_SELECTION = [
    'Brand',
    'Model',
    'ExtraFields.VehiclePurpose',
    'ExtraFields.DrivingOption',
    'ExtraFields.CustomizationOptions',
    'FuelType',
    'Transmission',
    'ColorNumber',
    'PriceOnline',
    'PriceLease',
    'Year',
    'Mileage',
    'Accessories.Items'
];

/**
 * A list of filters with the desired order.
 */
export const FILTER_ORDER = [
    'ExtraFields.VehiclePurpose',
    'ExtraFields.DrivingOption',
    'ExtraFields.CustomizationOptions',
    'Brand',
    'Model',
    'PriceOnline',
    'PriceLease',
    'Year',
    'Mileage',
    'FuelType',
    'Transmission',
    'Accessories.Items',
    'ColorNumber',
    'IsNew',
    'IsSpecialOffer',
    'Seats',
    'FinanceMethod'
];

/**
 * A list of filters that should be opened at first render.
 */
export const FILTERS_DEFAULT_OPENED = {
    'ExtraFields.VehiclePurpose': true,
    'ExtraFields.DrivingOption': true,
    'ExtraFields.CustomizationOptions': true,
    Brand: true,
    Model: false,
    PriceOnline: false,
    PriceLease: false,
    Year: false,
    Mileage: false,
    FuelType: false,
    Transmission: false,
    'Accessories.Items': false,
    ColorNumber: false,
    IsNew: false,
    IsSpecialOffer: false,
    Seats: false,
    FinanceMethod: false
};

export const filterInfo = {
    IsAdapted: {
        title: 'Aangepast filter',
        description: [
            'Aangepast: Ja. De getoonde auto beschikt over één of meerdere aanpassingen. De getoonde prijs is inclusief de aanpassing(en). ', 
            'Aangepast: Nee. De getoonde auto beschikt nog niet over een aanpassing. Deze kun je naar wens laten maken. De getoonde prijs is exclusief de aanpassing(en).'
        ]
    },
    'ExtraFields.DrivingOption': {
        title: 'Zelf rijden / Meerijden filter',
        description: [
            'Meerijden: de auto of bus is geschikt om als passagier mee te rijden. Bij personenauto’s dient de passagier een transfer uit het hulpmiddel te kunnen maken. Bij rolstoelauto’s en -bussen kan de passagier in het hulpmiddel blijven zitten.',
            'Zelf rijden: de auto of bus is geschikt om zelf te besturen wanneer je een hulpmiddel gebruikt. De personen- en rolstoelauto’s dien je een transfer uit het hulpmiddel te kunnen maken. Een rolstoelbus kan ook vanuit een hulpmiddel bestuurd worden.'
        ]
    },
    'ExtraFields.VehiclePurpose': {
        title: 'Type auto filter',
        description: [
            'Personenauto: een 3- of 5-deurs auto met vaak 4 tot 5 zitplaatsen. Geschikt om zelf in te rijden of om als passagier mee te rijden, indien je een transfer uit je hulpmiddel kunt maken.',
            'Rolstoelauto: een bestelauto die geschikt is om een rolstoel- of scootmobiel gebruiker als passagier in de auto te vervoeren, zonder een transfer uit het hulpmiddel te maken.',
            'Rolstoelbus: een bestelbus die geschikt is wanneer je vanuit een hulpmiddel de bus zelf wilt besturen. Je hoeft dus geen transfer te maken. Ook geschikt om een rolstoel- of scootmobielgebruiker als passagier in de auto te vervoeren.'
        ]
    },
}